/** Should be even number. If there is a need to change to odd number, need to modify the function logic too */
export const DAYS_TO_FETCH_ON_INIT_LOAD = 20;
